import type { AxiosError, AxiosResponse } from "axios";
import axios from "axios";
import { createQuery } from "react-query-kit";

import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import CorporationZoneModel from "../../models/masters/corporationzone-model";

const url = getEndPoint(API_END_POINT.MASTER) +"/api/CorporationZone/GetAllCorporationZone";// //{/api/Category/GetAllCategory}`)  //// "https://localhost:7054/api/Category/GetAllCategory";
export const useGetCorporationZone = createQuery<
CorporationZoneModel[],
  null,
  AxiosError
>({
  queryKey: ["keyCorporationZonelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});
